import { ResolveFn } from '@angular/router';
import { DestroyRef, inject } from '@angular/core';
import { PoRFPDetailsResponse } from '../models/po-rfp';
import { forkJoin } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonService } from '../services/common/common.service';
import { BankAccount } from '../Interfaces/bankAccount.interface';
import { PoRFPService } from '../services/po-rfp/po-rfp.service';

interface PoAllDetails {
  details: PoRFPDetailsResponse;
  bankDetails: {
    bank_account: BankAccount;
  };
}

export const poRFPDetailsResolver: ResolveFn<
  Pick<PoAllDetails, 'details'> | PoAllDetails
> = (route, state) => {
  const poService = inject(PoRFPService);
  const commonService = inject(CommonService);
  const destroyRef = inject(DestroyRef);

  const poId = route.params['id'];
  if (state.url.includes('buyer')) {
    return forkJoin({
      bankDetails: commonService.getContractorBankDetails(),
      details: poService.getBuyerPoRFPDetails(poId),
    }).pipe(takeUntilDestroyed(destroyRef));
  } else {
    return forkJoin({
      details: poService.getContractorPoRFPDetails(poId),
    }).pipe(takeUntilDestroyed(destroyRef));
  }
};
